import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Home from './Pages/Home'
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import OnlineEvents from './Pages/OnlineEvents';
import LiveEvents from './Pages/LiveEvents';
import About from './Pages/About';

function App() {
  return (
    <div className="app">
      <Router>
          <Switch>
            <Route exact path="/" component={Home}></Route>
            <Route exact path="/online" component={OnlineEvents}></Route>
            <Route exact path="/live" component={LiveEvents}></Route>
            <Route exact path="/about" component={About}></Route>
          </Switch>
      </Router>
    </div>
  );
}

export default App;
